import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../vendor/abridge-shared-ui.css';
import { loadDesignSystem } from './ds';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

const root = createRoot(container);

// The design system must be on window before the first render — see ds.ts.
loadDesignSystem().then(
  () =>
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  (error: unknown) => {
    // Rendering the failure beats a blank page: without the bundle there are no
    // components at all, so there is nothing the app could usefully fall back to.
    root.render(
      <div
        style={{
          padding: 40,
          fontFamily: 'ui-monospace, monospace',
          fontSize: 13,
          lineHeight: 1.6,
          color: '#ff8a80',
          background: '#2a1215',
          minHeight: '100vh',
        }}
      >
        <strong>Could not load AbridgeSharedUi.</strong>
        <br />
        {error instanceof Error ? error.message : String(error)}
        <br />
        <br />
        Expected the bundle at <code>web/public/abridge-shared-ui.js</code>.
      </div>,
    );
  },
);
